<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        :persistent="processing"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.resellerUser.resetPassword.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.resellerUser.resetPassword.p1') }}</p>
                <p>{{ $t('actions.resellerUser.resetPassword.p2') }}</p>
            </v-card-text>
            <v-card-text>
                <v-text-field
                    class="mt-6"
                    v-if="tempPassword"
                    prepend-icon="mdi-lock"
                    :label="'Senha Temporária'"
                    v-model="tempPassword"
                    readonly
                >
                </v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click="close"
                    :disabled="processing"
                >
                    {{ $t('actions.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="perform"
                    :loading="processing"
                    :disabled="processed"
                >
                    {{ $t('actions.resellerUser.resetPassword.perform') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            model: undefined,
            processing: false,
            processed: false,
            tempPassword: undefined,
        }
    },

    watch: {
        dialog(value) {
            if (value) return

            this.processed = false
            this.tempPassword = undefined
        },
    },

    methods: {
        open(model) {
            this.dialog = true
            this.model = model
        },

        close() {
            this.model = undefined
            this.dialog = false
        },

        async perform() {
            this.processing = true
            let res = await this.model.resetPassword()
            this.processing = false
            this.processed = true

            if (!res) return
            this.tempPassword = res.data.data.temporary_password

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.resellerUser.resetPassword.success'),
            )
        },
    },
}
</script>

<style></style>
